import React from "react";

interface LoadingProps {
  data?: {};
}

const ChartLoader: React.FC<LoadingProps> = ({ data }) => {
  return (
    <div className="rounded-lg bg-white py-3  lg:py-6 w-full">
      <div className="flex justify-between items-center animate-pulse px-3 md:px-6">
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
      </div>
      <hr className="border border-[#EAECF0] w-full mt-3 mb-2" />

      <div className="mt-3 animate-pulse px-3 py-2">
        <div className="animate-pulse relative w-full flex justify-center items-center">
          <span className="h-[200px] bg-[#E6EEF5] inline-block w-[200px] rounded-full"></span>
          <span className="h-[140px] bg-white absolute inline-block w-[140px] rounded-full"></span>
        </div>
      </div>

      <div className="flex justify-center items-center animate-pulse space-x-2 px-3 mt-5 mb-4 md:px-6">
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
        <span className="h-6 bg-[#E6EEF5] inline-block w-[30%] rounded-md"></span>
      </div>
    </div>
  );
};

export default ChartLoader;
